<template lang="html">
	<div class="placed-backg faqs-page" id="page-info-t1">

		<div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/faqs/bg.jpg)' }"></div>

		<section class="container oversized-container content-section">

			<div class="row align-items-center">

				<div class="col-lg-6 col-xl-5 col-info">

					<h1 class="mb-4 page-title">{{ 'faq' | static-title }}</h1>

					<static-markdown :content="'faq' | static-content"></static-markdown>

				</div>

				<div class="col-lg-5 col-xl-6 col-image"></div>

			</div>

		</section>

	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				name: null,
				email: null,
				phone: null,
				msg: null
			},
			redes: [],
		}
	},

	methods: {
		makeToast(variant = null, msg, title) {
			this.$bvToast.toast(msg, {
				title: title,
				variant: variant,
				solid: true,
				toaster: 'b-toaster-top-right',
				appendToast: true
			})
		},

		getRedes: function () {
			axios.get(tools.url('/redes')).then((response) => {
				this.redes = response.data;;
			}).catch((error) => {
				console.log(error);
			})
		},

		onSubmit(evt) {
			evt.preventDefault();
			//var data=tools.params(form, this.form);
			axios.post(tools.url("/contacto"), this.form).then((response) => {
				this.makeToast('default', response.data.response, 'Mensaje enviado');
				this.form = {
					name: null,
					email: null,
					msg: null,
					check: null
				};
			}).catch((error) => {
				// console.log(error.response);
				let errors = error.response.data;
				// console.log(errors);
				this.makeToast('danger', error.response.data.name, 'Error');
				this.makeToast('danger', error.response.data.email, 'Error');
				this.makeToast('danger', error.response.data.phone, 'Error');
				this.makeToast('danger', error.response.data.msg, 'Error');
			});
		}
	},

	beforeMount() {
		this.getRedes();

		if (this.$route.query.p) {
			this.form.msg = 'Me intresa el producto ' + this.$route.query.p;
		}
	}
}
</script>
